function isLogin() {
    const token = sessionStorage.token;
    return !!token && token.length > 10;
}

export {
    isLogin,
}


// WEBPACK FOOTER //
// ./src/modules/Authentication.js